import script from "./dpc-form-communicator.vue?vue&type=script&lang=js"
export * from "./dpc-form-communicator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__